import React from 'react';

function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#fff"
        d="M14 7.043a7 7 0 10-8.094 6.914v-4.89H4.13V7.041h1.777V5.501c0-1.754 1.046-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093v1.313h1.94l-.31 2.024h-1.63v4.891A7.003 7.003 0 0014 7.043z"
      />
    </svg>
  );
}

export default FacebookIcon;
